/**
 * The client's entry point.
 */

import { Auth0Provider } from '@auth0/auth0-react'; // for SSO
import { fromJS } from 'immutable';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { applyMiddleware, compose, createStore } from 'redux';
import { combineReducers } from 'redux-immutablejs';
import thunkMiddleware from 'redux-thunk';
import { init } from './actions/global';
import reducer from './reducers';
import { getRoutes } from './routes';
import { applyHighchartsDefaults } from './utils/highchartsDefaults';

applyHighchartsDefaults();

const auth0Config = {
  domain: 'login.trueprodigyapps.com',
  clientId: 'ELLxeadiAkmKJ9BhEKioFNGw1Sp1yDNF',
  authorizationParams: {
    audience: 'https://dev-wrmdvblhk07q5tkj.us.auth0.com/api/v2/',
    redirect_uri: window.location.origin,
  },
  cacheLocation: 'localstorage', // auth0 sessions were not registered by useAuth0 hook without this
};

// Enable react devtool support during development
if (process.env.NODE_ENV !== 'production') {
  // For dev tool support, attach to window...
  window.React = React;
}

const rootReducer = combineReducers({
  app: reducer(),
});

export function createOurStore(reducers, initialState) {
  const composeEnhancers =
    (__DEVELOPMENT__ &&
      typeof window !== 'undefined' &&
      window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;
  return createStore(
    reducers,
    initialState,
    composeEnhancers(applyMiddleware(thunkMiddleware)),
  );
}

async function boot() {
  // Create redux store
  const initialState = fromJS({});
  const store = createOurStore(rootReducer, initialState);

  await store.dispatch(init());
  // Render application
  ReactDOM.render(
    <Auth0Provider {...auth0Config}>
      <ReduxProvider store={store}>
        <BrowserRouter
          future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
        >
          {getRoutes(store)}
        </BrowserRouter>
      </ReduxProvider>
    </Auth0Provider>,
    document.getElementById('root'),
  );
}

boot();
